import React from "react";
import styled from "styled-components";
import PText from "../components/PText";
import Button from "../components/Button";
import AboutImg from "../assets/images/Marlo_Profile_Pic.png";
import AboutInfoItem from "../components/AboutInfoItem";
import ContactBanner from "../components/ContactBanner";

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;

  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
      line-height: 2rem;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
  }
`;

export default function About() {
  return (
    <>
      <AboutPageStyles>
        <div className="container">
          <div className="top-section">
            <div className="left">
              <p className="about__subheading">
                Hello, I am <span>Marlo Rouse</span>
              </p>
              <h2 className="about__heading">A freelance Web developer</h2>
              <div className="about__info">
                <PText>
                  I am a passionate web and app developer from Jacksonville,
                  North Carolina, a vibrant city with a strong community spirit.
                  My journey into coding began during a computer technology
                  course in community college, sparking a deep enthusiasm for
                  creating innovative digital solutions that enhance everyday
                  life.
                  <br /> <br />
                  With a solid foundation in web development, I thrive on the
                  challenge of designing and building user-friendly applications
                  that meet diverse needs. I embrace each day as a new
                  opportunity to learn and grow, constantly seeking out new
                  techniques and technologies to expand my skill set.
                  <br /> <br /> Creativity is at the core of my work; I love
                  transforming fresh ideas into functional, impactful projects.
                  I view challenges as opportunities to innovate, believing that
                  each obstacle can lead to groundbreaking solutions. I am eager
                  to contribute my skills and passion to a dynamic team, where I
                  can collaborate and help bring visionary ideas to life.
                </PText>
              </div>
              {/* <Button btnText="Download CV" btnLink="#" /> */}
            </div>
            <div className="right">
              <img src={AboutImg} alt="me" />
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1 className="about__info__heading">Education</h1>

              <AboutInfoItem
                title="School"
                items={["Washingtion High School, Washington NC"]}
              />
              <AboutInfoItem
                title="College"
                items={["Beaufort County Community College"]}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">My Skills</h1>

              <AboutInfoItem
                title="FrontEnd"
                items={[
                  "HTML",
                  "CSS",
                  "JavaScript",
                  "REACT",
                  "Next.js",
                  "Typescript",
                ]}
              />
              <AboutInfoItem
                title="BackEnd"
                items={["Node", "Express", "PHP", "Python", "MongoDB", "Sql"]}
              />
              <AboutInfoItem
                title="Design"
                items={[
                  "Photoshop",
                  "After Effects",
                  "Premiere Pro",
                  "Dreamweaver",
                  "Illustrator",
                  "Figma",
                ]}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">Experiences</h1>

              <AboutInfoItem
                title="2015-"
                items={["Freelance web Developer"]}
              />
            </div>
          </div>
        </div>
        <ContactBanner />
      </AboutPageStyles>
    </>
  );
}
